import { render, staticRenderFns } from "./SocialsEdit.vue?vue&type=template&id=10a137a4&lang=pug"
import script from "./SocialsEdit.vue?vue&type=script&lang=js"
export * from "./SocialsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports